import { cn } from '@ui/lib/utils';

interface BlurredDividerProps {
  className?: string;
}

/**
 * A reusable divider component with a blurred effect
 *
 * @param className - Optional class names to override default styling
 */
export function BlurredDivider({ className }: BlurredDividerProps) {
  return (
    <div
      className={cn('border-t border-slate-200/65 blur-[0.8px]', className)}
    />
  );
}
